angular.module('impactx.catalog').service('CatalogCheckinService', CatalogCheckinService);

CatalogCheckinService.$inject = ['dataGen'];

function CatalogCheckinService(dataGen) {

    this.checkIn = function (scope, id) {
        return dataGen.postAsForm(scope, {cat:{id:id}}, "/catalog/checkin");
    }

}